"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Col2 = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _RatingDisplaySingleStar = _interopRequireDefault(require("angieslist-react-components/lib/RatingDisplaySingleStar"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");

var _icons = require("@angi/icons");

var _analyticsDefaultProperties = require("../../analytics/analyticsDefaultProperties");

var _iconCircleAccount = _interopRequireDefault(require("./icon-circle-account.svg"));

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _Col, _i, _hr, _hr2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UnifiedHeaderFlyout = function UnifiedHeaderFlyout(_ref) {
  var logout = _ref.logout,
      numberOfBusinesses = _ref.numberOfBusinesses,
      proLocation = _ref.proLocation,
      proName = _ref.proName,
      proType = _ref.proType,
      rating = _ref.rating,
      reviewCount = _ref.reviewCount,
      sendEnhancedTrackEvent = _ref.sendEnhancedTrackEvent,
      displaySpId = _ref.displaySpId,
      userId = _ref.userId,
      isAngiLeads = _ref.isAngiLeads,
      isAdvertiser = _ref.isAdvertiser,
      isNorthStar = _ref.isNorthStar,
      isAgreementOnlineEnroll = _ref.isAgreementOnlineEnroll;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showFlyout = _useState2[0],
      setShowFlyout = _useState2[1];

  var calendarBannerCookieKey = 'spid_of_calendar_banner_closed';
  var flyoutRef = (0, _react.useRef)(null);

  var showHeaderFlyout = function showHeaderFlyout() {
    setShowFlyout(!showFlyout);
    sendEnhancedTrackEvent({
      name: 'Item Clicked',
      properties: _objectSpread(_objectSpread({}, _analyticsDefaultProperties.defaultProps), {}, {
        activityLocation: "".concat(proType === 'Angi Ads' ? 'Ads' : 'Leads', " Auth Header"),
        description: !showFlyout ? 'Profile dropdown opened' : 'Profile dropdown closed'
      })
    });
  };

  var signOut = function signOut() {
    (0, _cookieUtils.deleteCookie)(calendarBannerCookieKey);
    logout(userId);
  };

  var serviceProviderIdLabel = displaySpId ? "\u2022 ID: ".concat(displaySpId) : '';

  var closeFlyout = function closeFlyout() {
    setShowFlyout(false);
  };

  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (flyoutRef.current && !flyoutRef.current.contains(event.target)) {
        closeFlyout();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [flyoutRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header--flyout-icon",
    role: "button",
    tabIndex: 0,
    className: "unified-header--flyout-menu",
    onClick: showHeaderFlyout,
    onKeyDown: showHeaderFlyout,
    ref: flyoutRef
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "unified-header--flyout-right"
  }, _Col || (_Col = /*#__PURE__*/_react["default"].createElement(_Col2["default"], {
    md: 1,
    className: "flyout-menu-right-icon-wrapper hidden-xs hidden-sm"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "account-icon",
    src: _iconCircleAccount["default"]
  }))), /*#__PURE__*/_react["default"].createElement(_Col2["default"], {
    md: 6,
    className: "hidden-xs hidden-sm hidden-md"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    style: {
      marginBottom: '10px'
    }
  }, proName || '', /*#__PURE__*/_react["default"].createElement("i", {
    className: showFlyout ? 'icon icon-up-open' : 'icon icon-down-open',
    style: {
      color: '#FFFFFF'
    }
  })), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col2["default"], {
    id: "unified-header--flyout-right-pro-type-location"
  }, "".concat(proLocation || ''))))), showFlyout ? /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "unified-header-flyout-menu__content"
  }, /*#__PURE__*/_react["default"].createElement(_Col2["default"], {
    xs: 11
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-top",
    id: "unified-header--flyout-menu-pro-name"
  }, proName || ''), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-top",
    id: "unified-header--flyout-menu-location"
  }, "".concat(proLocation || '', " ").concat(serviceProviderIdLabel || '')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-top",
    id: "unified-header--flyout-menu-rating"
  }, /*#__PURE__*/_react["default"].createElement(_RatingDisplaySingleStar["default"], {
    rating: rating,
    ratingFontSize: "1.0em",
    starSize: "1.2em"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      marginLeft: 5,
      marginTop: 2
    }
  }, "(".concat(reviewCount, ")"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-top",
    id: "unified-header--flyout-menu-change-business"
  }, /*#__PURE__*/_react["default"].createElement(_icons.EditIcon, {
    contentProps: {
      fillColor: '#005F99'
    }
  }), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Edit profile",
    href: isAngiLeads ? _urlCatalog["default"].office.leads.businessSettings(displaySpId) : _urlCatalog["default"].office.ads.spProfile.edit(displaySpId),
    id: "unified-header--flyout-menu-edit-profile-link"
  }, "Edit profile"))), numberOfBusinesses > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-top",
    id: "unified-header--flyout-menu-change-business"
  }, _i || (_i = /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-arrow-toggle"
  })), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Switch business",
    href: _urlCatalog["default"].office.businessList(),
    id: "unified-header--flyout-menu-switch-business-link"
  }, "Switch business"))), _hr || (_hr = /*#__PURE__*/_react["default"].createElement("hr", {
    className: "unified-header--flyout-menu-divider"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-middle",
    id: "unified-header--flyout-menu-business-preferences"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "My preferences",
    href: _urlCatalog["default"].office.account.home(),
    id: "unified-header--flyout-menu-business-preferences-link"
  }, "Personal settings"))), !isAngiLeads && isAdvertiser && isNorthStar && isAgreementOnlineEnroll ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-middle",
    id: "unified-header--flyout-menu-premium-settings"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Angi Ads settings",
    href: _urlCatalog["default"].office.leads.agreementSettings(displaySpId),
    id: "unified-header--flyout-menu-premium-settings-link"
  }, "Angi Ads settings"))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-middle",
    id: "unified-header--flyout-menu-business-help"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Get help",
    href: _urlCatalog["default"].global.intercomAssistance(),
    id: "unified-header--flyout-menu-business-help-link"
  }, "Get help"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-middle",
    id: "unified-header--flyout-sign-out"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Sign out",
    href: "/",
    id: "unified-header--flyout-menu-sign-out-link",
    onClick: signOut
  }, "Sign out"))), _hr2 || (_hr2 = /*#__PURE__*/_react["default"].createElement("hr", {
    className: "unified-header--flyout-menu-divider"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header--flyout-menu-bottom"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Go to Angi.com",
    href: _urlCatalog["default"].drupalRoot,
    id: "unified-header--flyout-menu-angi-link"
  }, "Go to Angi.com"))))) : null);
};

UnifiedHeaderFlyout.defaultProps = {
  isAdvertiser: false,
  isNorthStar: false,
  isAgreementOnlineEnroll: true // TODO: BB-1795 will flip the default value to false

};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)))(UnifiedHeaderFlyout);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/unifiedHeaderFlyout.js
// module id = 3659
// module chunks = 25